import { withPublicHOC } from '../../hoc';
import {
  PublicContentContainer,
  PublicPageHeading,
  PublicPageContent,
} from '../../components/styled';

const PublicPage = ({ disclaimers }) => {
  return (
    <PublicContentContainer>
      <PublicPageHeading>
        <h1>Disclaimers</h1>
      </PublicPageHeading>
      <PublicPageContent
        className="content"
        dangerouslySetInnerHTML={{ __html: disclaimers }}
      ></PublicPageContent>
    </PublicContentContainer>
  );
};

export default withPublicHOC(PublicPage);
